import React, { useState, useMemo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from 'react-router-dom';
import {
    Container,
    Button,
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Alert
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    getAccountById as onGetAccount,
    updateAccount as onUpdateAccount,
    addAccount as onAddAccount,
    getCompanies as onGetCompanies
} from "../../store/actions";

import * as Yup from "yup";
import { useFormik } from "formik";

import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";

const AccountCreateUpdate = (props) => {

    //meta title
    document.title = "Account | Master Data | Des Counts";
    const id = props?.match?.params?.id;
    const companyId = props?.match?.params?.companyId;
    const isEdit = id != undefined && companyId != undefined;

    const { companies, account, loading, error } = useSelector(state => ({
        companies: state.Company.companies,
        account: state.Account.account,
        loading: state.Account.loading,
        error: state.Account.error,
    }));

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e)
        validation.setFieldValue("companyId", e.value.toString(), true)
    }

    const dispatch = useDispatch();
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: isEdit && account ? account.companyId : "",
            code: isEdit && account ? account.code : "",
            name: isEdit && account ? account.name : "",
            nama: isEdit && account ? account.nama : "",
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Please Select company"),
            code: Yup.string().required("Please Enter Code"),
            name: Yup.string().required("Please Enter Account Name"),
            nama: Yup.string().required("Please Enter Nama Akun"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                dispatch(onUpdateAccount({ id: account.id, companyId: account.companyId, name: values.name, nama: values.nama }, props.history));
            } else {
                dispatch(onAddAccount({
                    code: values.code,
                    name: values.name,
                    nama: values.nama,
                    companyId: parseInt(values.companyId)
                }, props.history));
            }
        },
    });


    useEffect(() => {
        dispatch(onGetCompanies({}))
        if (isEdit) {
            dispatch(onGetAccount(id, companyId))
        }
    }, [dispatch])

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (isEdit && account && companies) {
            var company = optionCompany.filter(s => s.value == account.companyId);
            if (company.length > 0) {
                setSelectedCompany(company[0])
            }
        }
    }, [optionCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Master Data" breadcrumbItem={(isEdit ? "Edit" : "Add") + " Account"} />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    {
                                        !loading &&
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form
                                                        className="form-horizontal"
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                    >
                                                        <div className="mb-3">
                                                            <Label>Company</Label>
                                                            <div
                                                                style={validation.errors.companyId ? { border: '1px solid #f46a6a', borderRadius: '0.25rem' } :
                                                                    { border: '0', borderRadius: '0.25rem' }}
                                                            >
                                                                <Select
                                                                    value={selectedCompany}
                                                                    onChange={handleSelectCompany}
                                                                    onBlur={validation.handleBlur}
                                                                    options={optionCompany}
                                                                    isDisabled={isEdit}
                                                                    className="select2-selection"
                                                                />
                                                            </div>
                                                            {validation.touched.companyId && validation.errors.companyId ? (
                                                                <FormFeedback className="d-block" type="invalid">Please select company</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <Row>
                                                            <Col className="col-12 col-sm-4">
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Code</Label>
                                                                    <Input
                                                                        name="code"
                                                                        className="form-control"
                                                                        placeholder="Enter account code"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.code || ""}
                                                                        disabled={isEdit}
                                                                        invalid={
                                                                            validation.touched.code && validation.errors.code ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.code && validation.errors.code ? (
                                                                        <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 col-sm-4">
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Name</Label>
                                                                    <Input
                                                                        name="name"
                                                                        className="form-control"
                                                                        placeholder="Enter account name"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.name || ""}
                                                                        invalid={
                                                                            validation.touched.name && validation.errors.name ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.name && validation.errors.name ? (
                                                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 col-sm-4">
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Nama</Label>
                                                                    <Input
                                                                        name="nama"
                                                                        className="form-control"
                                                                        placeholder="Enter nama akun"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.nama || ""}
                                                                        invalid={
                                                                            validation.touched.nama && validation.errors.nama ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.nama && validation.errors.nama ? (
                                                                        <FormFeedback type="invalid">{validation.errors.nama}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>


                                                        <div className="mt-3 mb-2">
                                                            <Link to="/masterdata/account">
                                                                <Button
                                                                    color="secondary"
                                                                    className="btn btn-secondary float-end"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Link>
                                                            <Button
                                                                color="primary"
                                                                className="btn btn-primary float-end me-2"
                                                                type="submit"
                                                            >
                                                                Submit
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loading &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

AccountCreateUpdate.propTypes = {
    history: PropTypes.object,
};

export default withRouter(AccountCreateUpdate)
